"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainsChainIdToParachainId = exports.chainsParachainIdToChainId = exports.chains = exports.chainName = exports.chainShortName = exports.chainShortNameToChainId = exports.chainIds = exports.Chain = exports.PARACHAIN_ID_MAP = exports.CHAIN_NAMES = exports.ChainKey = exports.ParachainId = exports.EthereumChainId = exports.Type = exports.Network = exports.Standard = void 0;
const chains_json_1 = __importDefault(require("./chains.json"));
const parachains_json_1 = __importDefault(require("./parachains.json"));
var Standard;
(function (Standard) {
    Standard["Eip3091"] = "EIP3091";
    Standard["None"] = "none";
})(Standard = exports.Standard || (exports.Standard = {}));
var Network;
(function (Network) {
    Network["Iorachain"] = "iorachain";
    Network["Mainnet"] = "mainnet";
    Network["Testnet"] = "testnet";
})(Network = exports.Network || (exports.Network = {}));
var Type;
(function (Type) {
    Type["L2"] = "L2";
    Type["Shard"] = "shard";
})(Type = exports.Type || (exports.Type = {}));
var EthereumChainId;
(function (EthereumChainId) {
    EthereumChainId[EthereumChainId["ASTAR"] = 592] = "ASTAR";
    EthereumChainId[EthereumChainId["MOONRIVER"] = 1285] = "MOONRIVER";
    EthereumChainId[EthereumChainId["MOONBEAM"] = 1284] = "MOONBEAM";
})(EthereumChainId = exports.EthereumChainId || (exports.EthereumChainId = {}));
var ParachainId;
(function (ParachainId) {
    ParachainId[ParachainId["ASTAR"] = 2006] = "ASTAR";
    ParachainId[ParachainId["MOONRIVER"] = 2023] = "MOONRIVER";
    ParachainId[ParachainId["MOONBEAM"] = 2004] = "MOONBEAM";
    ParachainId[ParachainId["BIFROST_KUSAMA"] = 2001] = "BIFROST_KUSAMA";
    ParachainId[ParachainId["BIFROST_POLKADOT"] = 2030] = "BIFROST_POLKADOT";
})(ParachainId = exports.ParachainId || (exports.ParachainId = {}));
var ChainKey;
(function (ChainKey) {
    ChainKey["ASTAR"] = "Astar";
    ChainKey["MOONBEAM"] = "Moonbeam";
    ChainKey["MOONRIVER"] = "Moonriver";
    ChainKey["BIFROST_KUSAMA"] = "Bifrost Kusama";
    ChainKey["BIFROST_POLKADOT"] = "Bifrost Polkadot";
})(ChainKey = exports.ChainKey || (exports.ChainKey = {}));
exports.CHAIN_NAMES = ['Astar', 'Moonbeam', 'Moonriver', 'Bifrost Kusama', 'Bifrost Polkadot'];
exports.PARACHAIN_ID_MAP = {
    'Astar': 2006,
    'Moonriver': 2023,
    'Moonbeam': 2004,
    'Bifrost Kusama': 2001,
    'Bifrost Polkadot': 2030,
};
const CHAINS = [...chains_json_1.default, ...parachains_json_1.default]
    .filter(chain => exports.CHAIN_NAMES.includes(chain.name))
    .map(chain => ({ ...chain, parachainId: exports.PARACHAIN_ID_MAP[chain.name] }));
class Chain {
    static from(chainId) {
        return exports.chains[chainId];
    }
    static fromShortName(shortName) {
        return exports.chains[exports.chainShortName[shortName]];
    }
    static fromChainId(chainId) {
        return exports.chains[chainId];
    }
    constructor(data) {
        Object.assign(this, data);
    }
    getTxUrl(txHash) {
        if (!this.explorers)
            return '';
        for (const explorer of this.explorers) {
            if (explorer)
                return `${explorer.url}/tx/${txHash}`;
        }
        return '';
    }
    getBlockUrl(blockHashOrHeight) {
        if (!this.explorers)
            return '';
        for (const explorer of this.explorers) {
            if (explorer.standard === Standard.Eip3091)
                return `${explorer.url}/block/${blockHashOrHeight}`;
        }
        return '';
    }
    getTokenUrl(tokenAddress) {
        if (!this.explorers)
            return '';
        for (const explorer of this.explorers) {
            if (explorer)
                return `${explorer.url}/token/${tokenAddress}`;
        }
        return '';
    }
    getAccountUrl(accountAddress) {
        if (!this.explorers)
            return '';
        for (const explorer of this.explorers) {
            if (explorer) {
                if (explorer.name === 'subscan')
                    return `${explorer.url}/account/${accountAddress}`;
                return `${explorer.url}/address/${accountAddress}`;
            }
        }
        return '';
    }
}
exports.Chain = Chain;
// ChainId array
exports.chainIds = CHAINS.map(chain => chain.parachainId);
// Parachain Short Name => Chain Id mapping
exports.chainShortNameToChainId = Object.fromEntries(CHAINS.map((data) => [data.shortName, data.parachainId]));
// Parachain Id => Short Name mapping
exports.chainShortName = Object.fromEntries(CHAINS.map((data) => [data.parachainId, data.shortName]));
// Parachain Id => Chain Name mapping
exports.chainName = Object.fromEntries(CHAINS.map((data) => [data.parachainId, data.name]));
// Parachain Id => Chain mapping
exports.chains = Object.fromEntries(CHAINS.map((data) => [data.parachainId, new Chain(data)]));
// Parachain Id => Ethereum ChainId mapping
exports.chainsParachainIdToChainId = Object.fromEntries(CHAINS.map((data) => [data.parachainId, data.chainId]));
// Ethereum ChainId => Parachain Id mapping
exports.chainsChainIdToParachainId = Object.fromEntries(CHAINS.map((data) => [data.chainId, data.parachainId]));
exports.default = exports.chains;
